import request from "./request";

export function getlogin(param) {
  return request({
    url: `/thousandSails/mutualTrust?accessToken=${param.accessToken}`,
    method: "get"
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js